module.exports = __webpack_public_path__ + "img/undset_Olav_Audunssoen1.c1db24c6.jpg";